import React from "react";

import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromHTML, ContentState } from "draft-js";
import draftToHtml from 'draftjs-to-html';
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./WysiwygTemplate.css";


class WysiwygTemplate extends React.Component {
  state = {
      editorState: null
  };

  componentDidMount() {
    let editorState = EditorState.createEmpty();
      if(this.props.value){
        const contentBlock = convertFromHTML(this.props.value);
        if(contentBlock.contentBlocks){
            const contentState = ContentState.createFromBlockArray(contentBlock);
            editorState = EditorState.createWithContent(contentState);
        }

        this.setState({
            editorState: editorState
        });
      }else{
          this.setState({editorState: editorState});
      }
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState: editorState
    }, () => {
        const raw = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));
        if(!this.isEmpty(raw)){
            this.props.onChange(raw);
        }else{
            this.props.onChange("");
        }
    });
  };

  isEmpty = (value) => {
    const contentBlock = convertFromHTML(value);
    if(contentBlock.contentBlocks){
        return false;
    }
    return true;
  };

  render() {
      const { editorState } = this.state;
    return (
        <React.Fragment>
            {editorState && <Editor editorState={this.state.editorState} onEditorStateChange={this.onEditorStateChange} /> }
        </React.Fragment>
    );
  }
}

export default WysiwygTemplate;
